import { useMemo, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import TopBar from '../components/TopBar';
import Footer from '../components/Footer';
import CountryCard from '../components/CountryCard';
import RevealProvider from '../components/RevealProvider';
import { COUNTRIES } from '../data/countries';

const FILTERS = [
  { key: 'all', label: 'All regions' },
  { key: 'europe', label: 'Europe' },
  { key: 'asia', label: 'Asia' },
  { key: 'americas', label: 'Americas' },
  { key: 'middle_east', label: 'Middle East' },
  { key: 'africa', label: 'Africa' },
  { key: 'under2k', label: 'Under $2,000/mo' },
  { key: 'tax', label: 'Tax-friendly' },
];

export default function CountriesList(){
  const [active, setActive] = useState('all');
  const list = useMemo(() => {
    switch (active){
      case 'all': return COUNTRIES;
      case 'under2k': return COUNTRIES.filter(c => c.minIncome < 2000);
      case 'tax': return COUNTRIES.filter(c => c.taxFriendly);
      default: return COUNTRIES.filter(c => c.region === active);
    }
  }, [active]);

  return (
    <RevealProvider>
      <Helmet>
        <title>All Digital Nomad Visa Countries — Nomad Compass</title>
        <meta name="description" content="Browse all 40+ digital nomad visa programmes by income, region, and tax treatment. Real data from official government sources." />
        <link rel="canonical" href="https://nomadcompasshub.com/countries" />
        <meta property="og:title" content="All Digital Nomad Visa Countries — Nomad Compass" />
        <meta property="og:description" content="Browse all 40+ digital nomad visa programmes." />
      </Helmet>
      <TopBar variant="page" />
      <section className="section countries-section" style={{ paddingTop: 140 }}>
        <div className="section-inner">
          <div className="section-head reveal">
            <div className="section-eyebrow">Countries we file for</div>
            <h2 className="section-title">40 programmes,<br/><em>one source of truth.</em></h2>
            <p className="section-sub">Every programme we work with. Filter by region, income, or tax treatment.</p>
          </div>
          <div className="countries-filters reveal">
            {FILTERS.map(f => (
              <button key={f.key} onClick={() => setActive(f.key)} className={`filter-chip ${active === f.key ? 'active' : ''}`} data-testid={`filter-${f.key}`}>{f.label}</button>
            ))}
          </div>
          <div className="countries-compare-cta reveal" data-testid="countries-compare-cta">
            <div className="countries-compare-cta-text">
              <strong>Comparing two or three?</strong>
              <span>Line up income, processing, validity, and tax — all in one table.</span>
            </div>
            <Link to="/compare" className="btn-primary countries-compare-cta-btn" data-testid="countries-compare-cta-btn">Compare visas →</Link>
          </div>
          <div className="countries-grid" data-testid="countries-grid">
            {list.map(c => <CountryCard key={c.slug} country={c} />)}
          </div>
        </div>
      </section>
      <Footer />
    </RevealProvider>
  );
}
